export * from "./jira-software-page.template";
export { JiraSoftwarePageTemplate as default } from "./jira-software-page.template";
